import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useStatistics } from '@/hooks/useStatistics';
import WebsiteClassifier from '../dashboard/WebsiteClassifier';
import RecentAnalyses from '../dashboard/RecentAnalyses';
import StatisticsCards from '../dashboard/StatisticsCards';
import BuyCreditsCard from '../dashboard/BuyCreditsCard';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

const Dashboard = () => {
    const { user } = useAuth();
    const {
        websitesAnalyzed,
        matchesFound,
        customTypes,
        remainingCredits,
        isLoading,
        error
    } = useStatistics(user?.id);

    return (
        <div className="space-y-6">
            {/* Stats Grid with Buy Credits Card */}
            <div className="flex items-start gap-4">
                <div className="flex-1">
                    <StatisticsCards
                        websitesAnalyzed={websitesAnalyzed}
                        matchesFound={matchesFound}
                        customTypes={customTypes}
                        remainingCredits={remainingCredits}
                        isLoading={isLoading}
                    />
                </div>
                <div className="w-px self-stretch bg-border hidden xl:block" /> {/* Vertical Separator */}
                <div className="hidden xl:block min-w-48">
                    <BuyCreditsCard />
                </div>
            </div>

            {/* Error Alert */}
            {error && (
                <div className="bg-destructive/10 border border-destructive text-destructive px-4 py-3 rounded-lg" role="alert">
                    <p className="text-sm font-medium">{error}</p>
                </div>
            )}

            {/* Main Content Grid */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                {/* Website Classifier */}
                <Card className="xl:col-span-1">
                    <CardHeader>
                        <CardTitle>Website Analysis</CardTitle>
                        <CardDescription>
                            Upload a CSV file with website URLs and select analysis types
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <WebsiteClassifier />
                    </CardContent>
                </Card>

                {/* Recent Analyses */}
                <div className="xl:col-span-1">
                    <RecentAnalyses />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;